export default function ({ $axios }) {
  $axios.defaults.timeout = 120000; // milisec.
  $axios.defaults.proxyTimeout = 120000; // milisec.
}